import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BioPage from '@/pages/BioPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BioPage />} />
          <Route path="*" element={<BioPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
